import { useEffect } from "react";

const IubendaLinks = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.src = "https://cdn.iubenda.com/iubenda.js";
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <a
        href="https://www.iubenda.com/privacy-policy/66629169"
        className="iubenda-white iubenda-embed"
        title="Privacy Policy"
        style={{ textDecoration: 'none', color: 'inherit', marginRight: '1rem', fontSize: '0.875rem' }}
      >
        Privacy Policy
      </a>
      <a
        href="https://www.iubenda.com/privacy-policy/66629169/cookie-policy"
        className="iubenda-white iubenda-embed"
        title="Cookie Policy"
        style={{ textDecoration: 'none', color: 'inherit', fontSize: '0.875rem' }}
      >
        Cookie Policy
      </a>
    </>
  );
};

export default IubendaLinks;
